import * as R from 'ramda'

export enum ResultsDisplayMode {
  All,
  Main,
  Others,
}

export function readResultsDisplayMode(str: string): ResultsDisplayMode | undefined {
  switch (str.toLowerCase()) {
    case 'all':
      return ResultsDisplayMode.All
    case 'main':
      return ResultsDisplayMode.Main
    case 'others':
      return ResultsDisplayMode.Others
    default:
      return undefined
  }
}

export const categoriesByResultDisplayMode = (resultMode: ResultsDisplayMode, categories) => {
  switch (resultMode) {
    case ResultsDisplayMode.All:
      return categories
    case ResultsDisplayMode.Main:
      return categories.filter(R.prop('main'))
    case ResultsDisplayMode.Others:
      return categories.filter(R.complement(R.prop('main')))
  }
}



// WEBPACK FOOTER //
// ./src/helpers/resultsDisplayMode.ts